import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../common/dropdown'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import { Tooltip } from '../../../common/tooltip'
import {
  changeAlertById,
  changeCheckedIds,
  changeFilter,
  changeLoading,
  selectAlertIdsAll,
  selectCheckedIds,
  selectFilter,
  selectTotalPages,
} from '../store/slice'
import { deleteAlert, markAsReadAlert, markAsUnreadAlert } from '../store/thunk'
import classes from './index.module.scss'

export const ToolBar = () => {
  const dispatch = useDispatch()

  const totalPages = useSelector(selectTotalPages)
  const filter = useSelector(selectFilter())
  const checkedIds = useSelector(selectCheckedIds())
  const alertIds = useSelector(selectAlertIdsAll)

  const listCheckedInCurrentPage = alertIds.filter((id) => checkedIds[id])

  const [isShow, setIsShow] = useState(false)

  const handleOpen = () => {
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const uncheckCurrentList = () => {
    const payload = listCheckedInCurrentPage.reduce(
      (prev, curr) => ({ ...prev, [curr]: false }),
      {},
    )
    dispatch(changeCheckedIds(payload))
  }

  const changeReadStatus = (isRead) => {
    const payload = listCheckedInCurrentPage.map((id) => ({
      path: [id, 'readStatus'],
      data: isRead,
    }))
    dispatch(changeAlertById(payload))
  }

  const handleDelete = () => {
    handleClose()
    uncheckCurrentList()
    dispatch(changeLoading({ alertList: true }))
    dispatch(deleteAlert({ alertIds: listCheckedInCurrentPage }))
      .unwrap()
      .then(() => {
        if (
          alertIds.length === listCheckedInCurrentPage.length &&
          filter.page > 1 &&
          filter.page === totalPages
        ) {
          dispatch(changeFilter({ page: filter.page - 1 }))
        } else {
          dispatch(changeFilter({ triggerChange: !filter.triggerChange }))
        }
      })
      .catch(() => {
        dispatch(changeLoading({ alertList: false }))
      })
  }

  const actions = [
    {
      icon: 'icon-email',
      tooltip: 'alerts.MARK_AS_UNREAD',
      color: '#0553A5',
      bgColor: '#EFF5FF',
      action: () => {
        uncheckCurrentList()
        changeReadStatus(false)
        dispatch(markAsUnreadAlert({ alertIds: listCheckedInCurrentPage }))
      },
    },
    {
      icon: 'icon-mail-open',
      tooltip: 'alerts.MARK_AS_READ',
      color: '#E8B714',
      bgColor: '#F6F0DC',
      action: () => {
        uncheckCurrentList()
        changeReadStatus(true)
        dispatch(markAsReadAlert({ alertIds: listCheckedInCurrentPage }))
      },
    },
    {
      icon: 'icon-trash-fill',
      tooltip: 'common.DELETE',
      color: '#2C73E8',
      bgColor: '#F2F7FF',
      action: handleOpen,
    },
  ]

  if (!listCheckedInCurrentPage.length) return null

  return (
    <>
      <Element className={classes.toolbar} style={{ color: '#3A414B' }}>
        <Translate
          value="alerts.ITEM_SELECTED_COUNT"
          count={listCheckedInCurrentPage.length}
          suffix={listCheckedInCurrentPage.length > 1 ? 's' : ''}
        />
        {actions.map((item, index) => (
          <Element
            key={index}
            className={classes.icon}
            style={{ backgroundColor: item.bgColor }}
            onClick={item.action}
          >
            <Tooltip
              tooltipContent={item.tooltip}
              isI18n
              position={positionDropdown.BOTTOM_CENTER}
              contentClass={classes.icon}
            >
              <Icon
                className={item.icon}
                style={{ color: item.color, fontSize: 15 }}
              />
            </Tooltip>
          </Element>
        ))}
      </Element>

      <PopupAction
        isShow={isShow}
        title="alerts.DELETE_ALERT_TITLE"
        btnCancel={{
          label: 'common.CANCEL',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'common.DELETE',
          isI18n: true,
          event: handleDelete,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate
              value="alerts.DELETE_ALERT_MESS_LIST"
              count={listCheckedInCurrentPage.length}
              suffix={listCheckedInCurrentPage.length > 1 ? 's' : ''}
            />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
